import { render, staticRenderFns } from "./AllSent.vue?vue&type=template&id=7276ef1e"
import script from "./AllSent.vue?vue&type=script&lang=js"
export * from "./AllSent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports